/* eslint-disable react/prop-types */
import React from 'react';
import { compose, pure, withState, withHandlers } from 'recompose';

import { Wrapper, RawInput } from './styled-components';

const Input = ({ type, name, required, onChange, value, handleOnFocus, isFocus, ...rest }) => (
  <Wrapper>
    <RawInput
      type={type}
      name={name}
      required={required}
      onChange={onChange}
      value={value}
      onFocus={handleOnFocus}
      onBlur={handleOnFocus}
      {...rest}
    />
  </Wrapper>
);

Input.defaultProps = {
  type: 'text',
  value: '',
  required: false,
  label: 'Label'
};

export default compose(
  withState('isFocus', 'setFocus', false),
  withHandlers({
    handleOnFocus: ({ setFocus, isFocus }) => () => setFocus(!isFocus)
  }),
  pure
)(Input);



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/Input/index.js